import { useIntl } from '@umijs/max';
import { useMemo } from 'react';

export enum ErrorType {
  old_password_not_correct = 'old_password_not_correct',
  user_exists_with_same_username = 'user_exists_with_same_username',
  mongo_error_duplicate = 'mongo_error_duplicate',
  is_duplicate = 'is_duplicate',
  unprocessable_entity = 'unprocessable_entity',
}

export const useError = (): Record<
  ErrorType | any,
  (params?: any) => string
> => {
  const intl = useIntl();

  return useMemo(
    () => ({
      unprocessable_entity: () =>
        intl.formatMessage({
          id: 'errors.unprocessable_entity',
          defaultMessage: 'Dữ liệu chưa đúng!',
        }),
      old_password_not_correct: () =>
        intl.formatMessage({
          id: 'errors.password_not_correct',
          defaultMessage: 'Mật khẩu cũ không đúng!',
        }),
      user_exists_with_same_username: () =>
        intl.formatMessage({
          id: 'errors.user_exists_with_same_username',
          defaultMessage: 'Tên đăng nhập đã tồn tại!',
        }),
      mongo_error_duplicate: () =>
        intl.formatMessage({
          id: 'errors.mongo_error_duplicate',
          defaultMessage: 'Có lỗi xảy ra, hãy kiểm tra dữ liệu nhập!',
        }),
      is_duplicate: (field?: string) =>
        intl.formatMessage(
          {
            id: 'errors.is_duplicate',
            defaultMessage: '{field} đã tồn tại',
          },
          { field },
        ),
      'userName already exist': () =>
        intl.formatMessage({
          id: 'errors.user_already_exists',
          defaultMessage: 'Tài khoản đã tồn tại, hãy nhập tên tài khoản khác!',
        }),
      'already register': () =>
        intl.formatMessage({
          id: 'errors.already_register',
          defaultMessage: 'Số điện thoại đã đăng ký',
        }),
    }),
    [intl.locale],
  );
};
